import {  Component, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../../../shared/shared.service';
import { MatTableDataSource, MatSort, Sort } from '@angular/material';
import {MatSnackBar, MatSnackBarModule} from '@angular/material/snack-bar';
import {UsagePaymentsService} from '../../../payment/usage-payments/usage-payments.service';
import * as FileSaver from 'file-saver';
import { AgentService } from '../../agent.service';
import { LocalStorageService } from 'angular-2-local-storage';
import {MatTableModule} from '@angular/material/table';

@Component({
  selector: 'app-chargeback-process',
  templateUrl: './chargeback-process.component.html',
  styleUrls: ['./chargeback-process.component.css'],
})
export class ChargeBackComponent implements OnInit {
  selectedFile: File;
  dataSource;
  displayedColumns = [];
  @ViewChild(MatSort) sort: MatSort;
  
  /**Pre-defined columns list for user table*/
  columnNames = [
    {
      id: 'ban',
      value: 'BAN',
    }, 
    {
    id: 'cardholder',
    value: 'Card Holder',},
    {
      id: 'amount',
      value: 'Amount',},
    {
        id: 'trandate',
        value: 'Transaction Date',},
    {
      id: 'error',
      value: 'OutCome',
    }];

  public process_btn:string;
  public export_btn:string;
  public download_btn_text:string;
  public fileValidationStatus:string;
  public is_loading: boolean;
  public disable_button: boolean;
  public disableExport_button: boolean;  
  public is_loader: boolean;
  public fileValidationFail: boolean;
  public fileValidationSucess: boolean;
  public chargeback_result: any = [];
  public chargeback = {};
  public chargeback_list: any = [];
  public chargeBackRequest: Object;
  public excelFile: File;

  http: any;
  private screen: string = 'chargeback_process';
  
  constructor(private sharedService: SharedService, private usagePaymentsService: UsagePaymentsService,  private agentService: AgentService,
              private localStorageService: LocalStorageService, private _snackBar: MatSnackBar) {
      this.download_btn_text = 'Download Template'
      this.process_btn = 'Upload CB File';
      this.export_btn = 'Download Validation Failures';
      this.is_loader = true;
      this.fileValidationStatus= "";
      this.fileValidationFail = false;
      this.fileValidationSucess = false;
      this.sharedService.setHeaderTitle(this.screen);
      this.sharedService.IsTheSessionValid(this.screen, true);
    }

  ngOnInit() {
    this.displayedColumns = this.columnNames.map(x => x.id); 
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 7000, verticalPosition:'top'
    });
  }

  openSnackBarColor(message: string, action: string, className: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
      panelClass: 'pogo-snackbar'
    });
  }

  generateDownload() {
    this.sharedService.setHeaderErrorMessage('chargeback_process', false, 'notification error', '');
    this.is_loading = true;
    const tmp_txt = this.download_btn_text;
    this.download_btn_text = 'File is preparing for download'
    this.disable_button = true;

    this.usagePaymentsService.getChargeBackTemplate()
      .then(async res => {
        if (res.ok) {
          this.is_loader = false;
          const blob = res.blob();
          if (blob != null) {
            this.is_loading = false;
            this.download_btn_text = tmp_txt;
            this.disable_button = false;
            const filename = 'ChargeBack-Template.xlsx';
            FileSaver.saveAs(blob, filename);
          } else {
            this.sharedService.setHeaderErrorMessage('chargeback_process', true, 'notification error', res.message);
            this.is_loading = false;
            this.download_btn_text = tmp_txt;
            this.disable_button = false;
          }
        }
      })
      .catch((err) => {
        this.is_loading = false;
        this.download_btn_text = tmp_txt;
        this.disable_button = true;
        this.sharedService.setHeaderErrorMessage('usage_payments', true, 'notification error',
          'There was an issue obtaining your template file, please try again.');
      })

  }

  uploadFile(fileInputEvent: any) {
    this.process_btn = 'Validating File...'
    this.disable_button = true;
    this.is_loading = true;
    this.dataSource = new MatTableDataSource(null);
    this.fileValidationSucess = false;
    this.fileValidationFail = false;
    this.selectedFile = null;
    this.sharedService.setHeaderErrorMessage('chargeback_process', false, 'notification error', '');
    if (fileInputEvent.length === 0) {
      return;
    }
    
    this.excelFile = fileInputEvent.target.files[0];

    this.agentService.validateChargeBackFile(fileInputEvent.target.files[0])
      .then(async res => {
        if (res.result.length > 0) {
          this.process_btn = 'Upload CB File';
          //this.disable_button = false;
          this.chargeback_result = res.result;
          this.is_loading = false;
          this.loadResultData(this.chargeback_result);
          if (res.validFile)
          {
            this.fileValidationStatus= "File Proccessed Successful";
            this.fileValidationSucess = true;
            this.openSnackBar('Upload has been successful, processing has started, and an email will be sent once completed.', 'Close');
            //this.openSnackBarColor('Upload has been successful, processing has started, and an email will be sent once completed.', 'Cerrar','pogo-snackbar');
            
            //Call ProcessChargeBackFile ------------------------------------------------------------------------------------
            this.agentService.sendChargeBackFile(this.localStorageService.get('agentToken'),fileInputEvent.target.files[0])
            .then(async res => {
              if (res.result.length > 0) {
                this.process_btn = 'Upload CB File';
                this.disable_button = false;
                this.chargeback_result = res.result;
                this.is_loading = false;
                this.sharedService.setHeaderErrorMessage('chargeback_process', false, 'notification error', '');
              }
            })
            .catch((err) => {
              this.is_loading = false;
              this.disable_button = false;
              this.sharedService.setHeaderErrorMessage('chargeback_process', true, 'notification error',
                'There was an issue validating your uploaded file, please try again.');
            })
            //--------------------------------------------------------------------------------------------
          }
          else
          {
            this.fileValidationStatus= "File Validation Failed";
            this.fileValidationFail = true;
          }
        }
      })
      .catch((err) => {
        this.is_loading = false;
        this.process_btn = 'Upload CB File';
        this.disable_button = false;
        this.sharedService.setHeaderErrorMessage('chargeback_process', true, 'notification error',
          'There was an issue validating your uploaded file, please try again.');
      })
  }

  loadResultData(chargeback_result: any) {
    this.chargeback_list = [];

    for (let i = 0; i < chargeback_result.length; i++) {
      this.chargeback = {
        "trandate" : chargeback_result[i].transactionDate,
        "cardholder" : chargeback_result[i].cardHolder,
        "amount" : chargeback_result[i].disputeAmount,
        "ban" : chargeback_result[i].ban,
        "error" :chargeback_result[i].outCome
      }; 

      this.chargeback_list.push(this.chargeback);
    }
    this.dataSource = new MatTableDataSource(this.chargeback_list);
    this.dataSource.sort = this.sort;
  }

  generateExportFile()
  {
    this.export_btn = 'Exporting File...'
    this.disableExport_button = true;
    this.is_loading = true;

    this.agentService.generateChargeBackErrorFile(this.excelFile)
    .then(async res => {
      if (res.ok) {
        const blob = res.blob();
        if (blob != null) {
          this.process_btn = 'Upload CB File';
          this.disable_button = false;
          this.chargeback_result = res.result;
          this.is_loading = false;
          this.sharedService.setHeaderErrorMessage('chargeback_process', false, 'notification error', '');
          const filename = 'ChargeBack-ErrorFile.xlsx';
          FileSaver.saveAs(blob, filename);
          this.chargeback_list = [];
          this.dataSource = new MatTableDataSource(this.chargeback_list);
          this.fileValidationFail = false;
          this.fileValidationStatus= "";
          this.disableExport_button = false;
          this.export_btn = 'Export File';
        } else {
          this.sharedService.setHeaderErrorMessage('chargeback_process', true, 'notification error', res.message);
          this.is_loading = false;
          this.disable_button = false;
        }
      }
    })
    .catch((err) => {
      this.is_loading = false;
      this.disable_button = true;
      this.disableExport_button = false;
      this.export_btn = 'Export File';
      this.fileValidationFail = true;
      this.sharedService.setHeaderErrorMessage('usage_payments', true, 'notification error',
        'There was an issue exporting your file, please try again.');
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/agent/agent-dashboard/chargeback-process/chargeback-process.component.ts